// Route label from what actually happened, not a country guess: all fulfillment now routes via
// ShipStation, so an order is 'Lulu' only when it really carries a Lulu print job id. The detail
// view still prefers the server-authoritative diagnostics.route when it has one.
export const routeLabel = (order?: { luluPrintJobId?: string | null } | null): 'ShipStation' | 'Lulu' =>
  order?.luluPrintJobId ? 'Lulu' : 'ShipStation';

// Deep link into the ShipStation web UI for a shipment. ShipStation has no documented stable
// URL scheme (and uses per-account subdomains), so we link to their order search by our order
// number — the most change-resistant route. Single source: every ↗ in the admin uses this.
export const shipstationOrderUrl = (orderNumber?: string | number | null): string | null =>
  orderNumber
    ? `https://ship.shipstation.com/orders/all-orders-search-result?quickSearch=${encodeURIComponent(String(orderNumber))}`
    : null;

// Deep link to the payment in the Stripe dashboard. Refunds are MANUAL there — nothing in our
// backend refunds or hears about refunds; this link is how an admin finds the right payment.
export const stripePaymentUrl = (paymentIntentId?: string | null): string | null =>
  paymentIntentId ? `https://dashboard.stripe.com/payments/${encodeURIComponent(String(paymentIntentId))}` : null;

/** Print-job chip text: prefer the human number, fall back to a shortened legacy doc id. */
export const printJobLabel = (order?: { printBatchNumber?: number | null; printBatchId?: string | null } | null): string | null => {
  if (order?.printBatchNumber) return `#${order.printBatchNumber}`;
  if (order?.printBatchId) return `${String(order.printBatchId).slice(0, 8)}…`;
  return null;
};
